// components/RemarkDialog.tsx
import { AxiosResponse } from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { getPlanSupportedCountries } from 'src/app/services/PlanService';

interface DialogProps {
  visible: boolean;
  onClose: () => void;
  header: string;
}

const CountryListDialog: React.FC<DialogProps> = ({
  visible,
  onClose,
  header,
}) => {
  const toast = useRef<Toast>(null);
  const [countries, setCountries] = useState<any[]>([]);
  const [search, setSearch] = useState('');

  const handleHide = () => {
    onClose();
  };

  const fetchPlanSupportedCountries = async () => {
    try {
      const response = await getPlanSupportedCountries() as AxiosResponse;
      console.log('response ', response);
      const localCountries = response?.data?.data['country'];
      const regions = response?.data?.data['regions'];

      setCountries(localCountries);
      // setCountries([...localCountries, ...regions]);
    } catch (error) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load countries.',
        life: 3000,
      });
    }
  };

  useEffect(() => {
    fetchPlanSupportedCountries();
  }, []);

  // 🔎 Filter countries based on search
  const filteredCountries = countries?.filter((country: any) =>
    country.display_title
      ?.toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        style={{ width: '30vw', height: '95vh' }}
        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        visible={visible}
        onHide={handleHide}
        // header={header}
        dismissableMask
        closable={false}
      >
        <div className="w-full py-6 ">
          <div className="grid">
            <div className='col-12 lg:col-12 px-6'>
              <InputText
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search"
                className="w-full"
              />
            </div>

            <div className="col-12 lg:col-12 px-6">
              <div className="grid grid-nogutter border-round-lg text-center">
                {filteredCountries?.map((country: any) => (
                  <div
                    key={country.iso_code_alpha_2}
                    className="col-12 p-2"
                  >
                    <div className="border-1 border-gray-300 surface-card p-3 border-round-lg flex align-items-start gap-2">
                      <img
                        src={`https://flagcdn.com/w40/${country.iso_code_alpha_2?.toLowerCase()}.png`}
                        alt={country.display_title}
                        style={{
                          width: '32px',
                          height: '24px',
                          objectFit: 'cover',
                        }}
                      />
                      <span className="font-bold">
                        {country.display_title}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default CountryListDialog;
